export default __webpack_public_path__ + "static/media/ChevronLeftFilled.c18cc471.svg";